import { useState, useCallback } from 'react';
import type { AnalyticsFilters } from '@/types/analytics.types';
import { getCurrentMonthRange } from '../utils/dateRange';

const { dateFrom, dateTo } = getCurrentMonthRange();

const DEFAULT_FILTERS: AnalyticsFilters = {
  ou: '',
  bu: '',
  dept: '',
  gerencia: '',
  dateFrom,
  dateTo,
  fundFilter: '',
  searchQuery: '',
};

export interface UseAnalyticsFiltersReturn {
  filters: AnalyticsFilters;
  setFilter: <K extends keyof AnalyticsFilters>(key: K, value: AnalyticsFilters[K]) => void;
  resetFilters: () => void;
}

export function useAnalyticsFilters(): UseAnalyticsFiltersReturn {
  const [filters, setFilters] = useState<AnalyticsFilters>(DEFAULT_FILTERS);

  const setFilter = useCallback(
    <K extends keyof AnalyticsFilters>(key: K, value: AnalyticsFilters[K]) => {
      setFilters((prev) => ({ ...prev, [key]: value }));
    },
    [],
  );

  const resetFilters = useCallback(() => {
    setFilters(DEFAULT_FILTERS);
  }, []);

  return { filters, setFilter, resetFilters };
}
